import { Box, ToggleButton, Typography } from '@mui/material';
import circleCheckedIcon from 'assets/icons/circle-check.svg';
import circleUncheckedIcon from 'assets/icons/circle-xmark.svg';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import { castArray } from 'lodash-es';
import theme from 'providers/theme/theme';
import type { FC } from 'react';
import { StatusToggleIconWrapperStyle, StatusToggleStyle } from './StatusToggle.styles';
import type { StatusToggleProps } from './StatusToggle.types';

const StatusToggle: FC<StatusToggleProps> = ({
  selectedText,
  notSelectedText,
  selectedBgColor = theme.palette.customColors.success,
  notSelectedBgColor = theme.palette.customColors.errorRed,
  selected,
  ...rest
}) => {
  const biggerStatusWordLength = Math.max(selectedText.length, notSelectedText.length);

  return (
    <ToggleButton
      {...rest}
      selected={selected}
      sx={[
        {
          backgroundColor: `${selected ? selectedBgColor : notSelectedBgColor} !important`,
          paddingInline: selected ? '.5rem 1.75rem' : '1.75rem .5rem',
        },
        StatusToggleStyle,
        ...castArray(rest.sx),
      ]}
    >
      <Typography
        variant="h3"
        sx={{
          width: `${biggerStatusWordLength - 1.5}ch`,
          textAlign: selected ? 'start' : 'end',
        }}
      >
        {selected ? selectedText : notSelectedText}
      </Typography>

      <Box
        component="span"
        sx={[
          {
            order: selected ? '1' : '-1',
            inset: selected ? '0 .125rem 0 auto' : '0 auto 0 .125rem',
          },
          StatusToggleIconWrapperStyle,
        ]}
      >
        <SvgIconWrapper src={selected ? circleCheckedIcon : circleUncheckedIcon} />
      </Box>
    </ToggleButton>
  );
};

export default StatusToggle;
